import Account from "./Routes/AOF";
import { Routes, Route, Navigate, Link } from "react-router-dom";
import Dashboard from "./Routes/Dashboard";
import Navbar from "./Atoms/Navbar";
import Login from "./Routes/Account/Login";
import Register from "./Routes/Account/Register";
import Verification from "./Routes/Account/Verification";
import ForgetPassword from "./Routes/Account/ForgetPassword";
import CreateNewPass from "./Routes/Account/CreateNewPass";
import EmailVerification from "./Routes/Account/EmailVerification";
import PasswordReset from "./Routes/Account/ResetPassword";
import InitalForm from "./Routes/InitalForm";
import Otp from "./Routes/Otp";
import SuccessFormScreen from './Routes/Otp/SuccessForm'
import ProtectedRoutes from "./ProtectedRoutes";
import Firebase from "./Routes/Account/firebase";
import VerifiedEmail from './Routes/Account/VerifiedEmail'
import EditFormErrorScreen from '../Component/Routes/Otp/EditFormAfterError'

const MainComponent = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/Redirect" element={<Firebase />} />
        <Route path="/ForgetPassword" element={<ForgetPassword />} />
        <Route path="/CreateNewPass" element={<CreateNewPass />} />
        <Route path="/Verification" element={<Verification />} />
        <Route path="/VerifiedEmail" element={<VerifiedEmail />} />
        <Route path="/heartbeatz" render={() => <h1> Heart Beats</h1>} />

        <Route element={<ProtectedRoutes />}>
          <Route path="/Email-Verification" element={<EmailVerification />} />
          <Route path="/PasswordReset" element={<PasswordReset />} />
          <Route path="/Initial-Detail" element={<InitalForm />} />
          <Route path="/Otp" element={<Otp />} />
          <Route path="/successotp" element={<SuccessFormScreen />} />

          <Route path="/Dashboard" element={<Dashboard />} />

          <Route path="/AOF" element={<Account />} />
          <Route path="/error" element={<EditFormErrorScreen />} />
        </Route>
      </Routes>
    </>
  );
};

export default MainComponent;
